import React, { useContext, useEffect } from "react";
import DataContext from "../../../Context";
import { IPolicy } from "../../../Models/PolicyInfo";
import "./Confirmation.scss";
import "../index.css";
import { getLoginURL } from "../../../Utils/getLoginURL";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../../Localization/LanguageContext";
import { LandingPage } from "../../../Components/LandingPage/LandingPage";
import { Button } from "@saif/button";
import { Paragraph } from "@saif/paragraph";

const Confirmation = () => {
  const { permPolicyClaim, permReportPay, permCertificates, setAppHasState } =
    useContext(DataContext) as IPolicy;
  const { getValue, locale } = useContext(
    LocalizationContext
  ) as ILocalizationContext;

  useEffect(() => {
    setAppHasState(false);
  }, []);

  return (
    <LandingPage
      iconProps={{
        icon: "circle-user",
        size: "xxl",
      }}
      headingProps={{
        size: "xl",
        center: true,
        children: getValue("Confirmation", "Title"),
      }}
      description={
        <>
          <Paragraph>
            {getValue("Confirmation", "BulletHeading")}
            <ul>
              {permPolicyClaim && (
                <li>
                  {getValue("Confirmation", "Bullet1")}
                  {locale === "es"
                    ? !permReportPay && !permCertificates
                      ? "."
                      : ";"
                    : ""}
                </li>
              )}
              {permReportPay && (
                <li>
                  {getValue("Confirmation", "Bullet2")}
                  {locale === "es" ? (!permCertificates ? "." : ";") : ""}
                </li>
              )}
              {permCertificates && (
                <li>{getValue("Confirmation", "Bullet3")}</li>
              )}
            </ul>
          </Paragraph>
          <Button
            as="a"
            id="confirmation-button"
            variant="fill"
            color="primary"
            href={getLoginURL(locale)}
          >
            {getValue("Confirmation", "Login")}
          </Button>
        </>
      }
    />
  );
};

export default Confirmation;
